import React from 'react';
import clsx from 'clsx';
import { hashClass } from '../../../helpers';
import { useTrilogyContext } from '../../../context';
import { has, is } from '../../../services';
import { getBackgroundClassName, getColorClassName } from '../../../objects';
/**
 * Table Body Component
 * @param children {ReactNode} children of Table Body
 * - -------------------------- WEB PROPERTIES -------------------------------
 * @param className {string} Additionnal CSS Classes
 * @param color {TrilogyColor} text color
 * @param backgroundColor {TrilogyColor} background color
 */
const TableBody = ({ className, color, backgroundColor, ...others }) => {
    const { styled } = useTrilogyContext();
    const classes = hashClass(styled, clsx(className, backgroundColor && has(getBackgroundClassName(backgroundColor)), color && is(getColorClassName(color))));
    return React.createElement("tbody", { className: classes, ...others });
};
export default TableBody;
//# sourceMappingURL=TableBody.js.map